import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'lk-formdata'

export const LK_PUBLICATIONS_FORMDATA_ROUTES = {
  LAYOUT: MODULE_NAME,
  FORM: `${MODULE_NAME}.form`,
} as const


export const createLKPublicationsFormdataModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataModal" */
    './LKPublicationsFormdataModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPublicationsFormdataListModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataListModal" */
    './LKPublicationsFormdataListModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPublicationsFormdataHistoryListModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataHistoryListModal" */
    './LKPublicationsFormdataHistoryListModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPublicationsFormdataRevisionsListModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataRevisionsListModal" */
    './LKPublicationsFormdataRevisionsListModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const LKPublicationsFormdataReportModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataReportModal" */
    './LKPublicationsFormdataReportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPublicationsFormdataTableEditModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataTableEditModal" */
    './components/Modals/LKPublicationsFormdataTableEditModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createLKPublicationsFormdataErrorsModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "LKPublicationsFormdataErrorsModal" */
    './components/Modals/LKPublicationsFormdataErrorsModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
